import { useEffect, useRef, useState } from 'react'
import { Box, IconButton, Tooltip, Typography, styled } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import _, { set } from 'lodash'
import iconAddFile from 'assets/icon/doctor-note/add-file.svg'

import iconCreatedBy from 'assets/icon/doctor-note/iconCreatedBy.svg'
import iconCreatedAt from 'assets/icon/doctor-note/iconCreatedAt.svg'
import iconUpdateBy from 'assets/icon/doctor-note/iconUpdateBy.svg'
import iconUpdateAt from 'assets/icon/doctor-note/iconUpdateAt.svg'

import ButtonCustom from 'component/Button/ButtonCustom'
import { colors } from 'constants/theme'
import TreatmentApi, { PayloadDoctorNote } from 'api/dentists/treatment.api'
import { getBranch, getClinicInfo, toBuddhistYear } from 'utils/app.utils'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { handleShow, resetModal, showModal } from 'app/slice/modal.slice'
import { icons, onImgError } from 'constants/images'
import { swalDelete } from 'component/Alert/Swal'

import * as UseStyled from 'features/treatments/MainMenu/DoctorNote/UseStyled'
import moment from 'moment'
import useWindowSize from 'utils/useWindowSize'
import CanvasDisign, { ImgIconDoctorNote, StatusNoteProps } from './canvas-draw'
import iconPrint from 'assets/icon/iconPrint.png'
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas'
import MainButton from 'new-components/buttons/main-button'
import IconPencil from 'assets/icon/doctor-note/iconPencil'
import IconRubber from 'assets/icon/doctor-note/iconRubber'
import AddIcon from '@mui/icons-material/Add';
import useClickOutside from 'utils/useClickOutSide'
import { ChromePicker } from 'react-color'
import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';
import TextAreaInput from 'new-components/inputs/text-area-input'
import PageModal from 'new-components/modal/page-modal'
import TextInput from 'new-components/inputs/text-input'

/** STYLE */

const DivDoctorNote = styled('div')<{ brushColor?: string }>(({ theme, brushColor }) => ({
  height: '100%',
  padding: '0 0.75rem',
  '& .img-add-note': { maxWidth: '50px', maxHeight: '50px' },
  '& .list-doctor-note': {
    width: '200px',
    height: '234px',
    border: `1px solid ${colors.lightGray}`,
    '&.active': { border: `1px solid ${colors.themeSecondColor}` }
  },
  '& .palette': {
    width: 235,
    textAlign: 'center',
    '& .palette-weight': {
      cursor: 'pointer',
      width: 25,
      height: 25,
      margin: '0.05rem',
      border: `1px solid ${colors.lightGray}`,
      borderRadius: '50%',
      '&.active': { border: `1px solid ${colors.black}` },
      '& .point-size': { backgroundColor: colors.black, borderRadius: '50%' }
    },
    '& .palette-color': {
      cursor: 'pointer',
      width: 25,
      height: 25,
      margin: '0.05rem',
      border: `1px solid ${colors.lightGray}`,
      borderRadius: '50%',
      '&.active': { border: `1px solid ${colors.black}` }
    }
  },
  '& .dropdown-doctor-note': { position: 'absolute', top: 5, right: 0 },
  '.btn-pencil, .btn-more': {
    boxShadow: 'none !important'
  }
}))


interface DoctorNoteProps {
  userId?: number
  patient?: any
  hasDoctorNote: 'PERMISS' | 'UNPERMISS'
  hasCreateDoctorNote?: 'PERMISS' | 'UNPERMISS'
  hasDeleteDoctorNote?: 'PERMISS' | 'UNPERMISS'
  isHistoryTreatment?: boolean
}
type VisitType = {
  patientCaseId: number
  branchId: number
  vnNumber: string | number
  createdAt: string
}
enum TreatmentType {
  'ALL',
  'VN_NUMBER',
  'NOT_VN_NUMBER'
}

export default function IndexDoctorNote(props: DoctorNoteProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const modal: boolean = useSelector(handleShow)
  const [width] = useWindowSize()

  const pencilRef = useRef(null)
  const rubberRef = useRef(null)
  const canvasRef: any = useRef<ReactSketchCanvasRef>(null);
  const [visitActive] = useState<string | number>(TreatmentType.ALL)

  const [brushColor] = useState<string>(colors.black)
  const [brushSize] = useState<number>(0)

  /** data use */

  const [isSavePopup, setIsSavePopup] = useState<boolean>(false)
  const [patientId, setPatientId] = useState<number>(1)
  const [listDoctorNote, setListDoctorNote] = useState<any[]>([])
  const [patientCaseId] = useState('')

  const [doctorNoteId, setDoctorNoteId] = useState<number>(0)
  const [doctorNoteDetail, setDoctorNoteDetail] = useState<any>()
  const [createNewNote, setCreateNewNote] = useState<any>(true)
  const [saveDoctorNote] = useState<PayloadDoctorNote>({
    patientId: 8,
    branchId: 1,
    patientCaseId: 0,
    userId: 0,
    doctorNoteName: '',
    base64Note: '',
    base64New: '',
    doctorNoteType: "WRITE",
    textNote: '',
    objectNote: {}
  })
  const [showDocumentDoctorNote, setShowDocumentDoctorNote] = useState<boolean>(true)
  const [saveDoctorNoteDataURL, setSaveDoctorNoteDataURL] = useState<any>()
  const [saveDoctorNoteDataObject, setSaveDoctorNoteDataObject] = useState<any>()

  const [listDoctorNoteText, setListDoctorNoteText] = useState<any[]>([])
  const [statusNote, setStatusNode] = useState<StatusNoteProps>('WRITE')
  const [textDoctorNote, setTextDoctorNote] = useState<string>('')
  const [listSelectDoctorNote, setListSelectDoctorNote] = useState<any[]>([])

  const [canvasData, setCanvasData] = useState('')
  const [canvasImageData, setCanvasImageData] = useState('')

  const [isOpenPencil, setIsOpenPencil] = useState(false)
  const [isOpenRubber, setIsOpenRubber] = useState(false)
  const [colorCanvas, setColorCanvas] = useState('black')
  const [color, setColor] = useState(false)
  const [pencilWidth, setPencilWidth] = useState(8)
  const [rubberWidth, setRubberWidth] = useState(8)
  const [dataImage, setDataImage] = useState('')
  const [titleNote, setTitleNote] = useState('New Note')

  const [dataCanvas, setDataCanvas] = useState<any>()

  useClickOutside(pencilRef, () => setIsOpenPencil(false))
  useClickOutside(rubberRef, () => setIsOpenRubber(false))
  const handleEditCanvas = (objEdit?: any, index?: number) => {
    handleSelectListDoctorNote(objEdit)
    canvasRef.current && canvasRef.current.clearCanvas();
    if (objEdit) {
      const data = JSON.parse(objEdit.objectNote)

      if (data?.objects) {
        setDataCanvas(objEdit.base64Note)
        setDataImage(objEdit.base64Note)
      } else {
        if (!isFutureDate(objEdit.createdAt)) {
          canvasRef.current && canvasRef.current.clearCanvas();
          setDataImage(objEdit.base64Note)
        } else {
          setDataImage('')
        }
        if (canvasRef.current && data) {
          setDataCanvas(data)
          canvasRef.current.clearCanvas();
          canvasRef.current && canvasRef.current.loadPaths(data)
        }
      }
      if (statusNote === "WRITE") {
        setDoctorNoteDetail(objEdit)
        setTitleNote(objEdit.doctorNoteName)
        setDoctorNoteId(objEdit.doctorNoteId)
        return
      } else {
        setCanvasData(JSON.parse(objEdit.objectNote))
        setTextDoctorNote(objEdit?.textNote)
        setDoctorNoteDetail(objEdit)
        setDoctorNoteId(objEdit.doctorNoteId)
      }
    } else {
      if (doctorNoteId === 0) {
        setDoctorNoteId(1)
        setDoctorNoteId(0)
      } else {
        setDoctorNoteId(0)
      }
    }
  }

  useEffect(() => {
    const { patientId: id } = props.patient
    setPatientId(id)
    loadDoctorNote(id)
  }, [props.patient])

  useEffect(() => {
    setListSelectDoctorNote([])
  }, [statusNote])

  // useEffect(() => {
  //   let canvas = document.querySelector("canvas") as HTMLCanvasElement | null;
  //   if (canvas) {
  //     canvas.getContext("2d", { preserveDrawingBuffer: true, willReadFrequently: true });

  //   }
  //   canvas = canvasRef.current?.canvas;
  //   if (canvas) {


  //     const ctx = canvas.getContext('2d');
  //     if (ctx) {
  //       ctx.lineJoin = 'round'; // ทำให้เส้นเชื่อมกันเนียน
  //       ctx.lineCap = 'round';  // ทำให้ปลายเส้นกลม
  //     }
  //   }
  // }, [canvasRef.current]);



  const handleCanvasSubmit = (dataURL: any, dataObject: any) => {
    setSaveDoctorNoteDataURL(dataURL)
    setSaveDoctorNoteDataObject(dataObject)
    handleSave()
  }

  const handleNewCanvas = () => {
    setDataImage('')
    setDataCanvas(null)
    setDoctorNoteId(0)
    setDoctorNoteDetail(null)
    setTextDoctorNote('')
    if (canvasRef.current) {
      canvasRef.current.clearCanvas();
    }
  }
  // const handleChangeHTMLTextNode = (info: any) => {
  //   const htmlTagPattern = /<[^>]+>/;
  //   if (!htmlTagPattern.test(info)) {
  //     return info;
  //   }

  //   const tempDiv = document.createElement('div');
  //   tempDiv.innerHTML = info;

  //   const textContent = Array.from(tempDiv.querySelectorAll('*'))
  //     .map((element) => element.textContent?.trim())
  //     .filter((text) => text)
  //     .join('\n');

  //   return textContent;
  // };

  const isFutureDate = (dateString: string): boolean => {
    const date = new Date(dateString);
    const now = new Date(2568 - 543, 0, 5);
    return date > now;
  };

  const handleChangeHTMLTextNode = (info: any) => {
    const htmlTagPattern = /<[^>]+>/;
    if (!htmlTagPattern.test(info)) {
      return info;
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = info;
    const elements = tempDiv.querySelectorAll('*');
    const textContent = Array.from(elements)
      .map(element => element.textContent)
      .join('\n');
    return textContent;
  }

  const loadDoctorNote = async (pId?: number) => {
    setListDoctorNote([])
    setListDoctorNoteText([])
    await TreatmentApi.doctorNoteList(pId || patientId).then(({ data }) => {
      if (data?.length) {
        const newWrite: any = []
        const newText: any = []
        data.forEach((item: any) => {
          if (item?.doctorNoteType === 'WRITE') {
            newWrite.push(item)
          } else {
            const newItem = { ...item, textNote: handleChangeHTMLTextNode(item?.textNote || '') }
            newText.push(newItem)
          }
        });
        setListDoctorNote(newWrite)
        setListDoctorNoteText(newText)
      }
    })
  }

  const openShowDocumentDoctorNote = async () => {
    showDocumentDoctorNote === true ? setShowDocumentDoctorNote(false) : setShowDocumentDoctorNote(true)
  }

  const submit = async (name: any, data?: any, image?: any) => {
    setIsSavePopup(false)
    if (canvasRef.current) canvasRef.current.clearCanvas();
    if (props.patient) {
      const { patientId: valuePatientId, patientCase } = props.patient
      let patientCaseIdDefault = null
      if (patientCase) patientCaseIdDefault = patientCase.patientCaseId
      const payload: PayloadDoctorNote = {
        patientId: valuePatientId,
        patientCaseId: Number(patientCaseId) || patientCaseIdDefault,
        branchId: getBranch(),
        userId: props?.userId || 0,
        doctorNoteName: name || doctorNoteDetail?.doctorNoteName || 'New Note',
        // base64Note: statusNote === 'TEXT' ? '' : image || '',
        base64New: statusNote === 'TEXT' ? '' : image || '',
        doctorNoteType: statusNote,
        textNote: statusNote === 'TEXT' ? textDoctorNote : '',
        objectNote: JSON.stringify(data)
      }
      setDataImage('')
      setTitleNote('New Note')
      if (canvasRef.current) {
        canvasRef.current.clearCanvas();
      }
      if (doctorNoteId !== 0) {
        const tempPayload: PayloadDoctorNote = { ...payload }
        delete tempPayload.patientId
        update(tempPayload, doctorNoteId)
      } else create(payload)

    }
  }
  const create = async (payload: PayloadDoctorNote) => {
    TreatmentApi.doctorNoteStore(payload)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          loadDoctorNote()
          handleNewCanvas()
          notiSuccess(t(`DOCTOR_NOTE.MESSAGE.SUCCESS.CREATE`), '', null, null, !props.isHistoryTreatment ? 'register-page' : '')
          setTextDoctorNote('')
          canvasRef.current?.clearCanvas()
        }
      })
      .catch((e) => {
        const err = e.response?.data
        notiError(t(`DOCTOR_NOTE.MESSAGE.${err.message}`), '', null, null, !props.isHistoryTreatment ? 'register-page' : '')
      })
  }

  const update = async (payload: PayloadDoctorNote, valueDoctorNoteId: number) => {
    TreatmentApi.doctorNoteUpdate(payload, valueDoctorNoteId)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          loadDoctorNote()
          handleNewCanvas()
          notiSuccess(t(`DOCTOR_NOTE.MESSAGE.SUCCESS.CREATE`), '', null, null, !props.isHistoryTreatment ? 'register-page' : '')
          setTextDoctorNote('')
          canvasRef.current?.clearCanvas()
        }
      })
      .catch((e) => {
        const err = e.response.data
        notiError(t(`DOCTOR_NOTE.MESSAGE.${err.message}`), '', null, null, !props.isHistoryTreatment ? 'register-page' : '')
      })
  }

  const handleSelectListDoctorNote = (data: any) => {
    const newKey = 'doctorNoteId'
    const id = data[newKey]
    if (listSelectDoctorNote && listSelectDoctorNote.some((item: any) => item[newKey] === id)) {
      const newListSelect = listSelectDoctorNote.filter((item) => item[newKey] !== id)
      setListSelectDoctorNote(newListSelect)
      return
    }
    setListSelectDoctorNote([...listSelectDoctorNote, data])
  }

  const detroy = async (valueDoctorNoteId: number) => {
    swalDelete(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('DOCTOR_NOTE.ALERT.CONFIRM_DELETE')}</p>`,
      `<p class="text-center  mb-0 mx-auto" style="max-width: 306px">${t(`DOCTOR_NOTE.ALERT.CONFIRM_DELETE_DETAIL`)} </p>`,
      (res: any) => {

        if (res && props.hasDeleteDoctorNote === 'PERMISS') {
          TreatmentApi.doctorNoteDelete(valueDoctorNoteId)
            .then((resp: any) => {
              if (resp.status !== undefined && resp.status === 200) {
                loadDoctorNote()
                notiSuccess(t(`DOCTOR_NOTE.MESSAGE.SUCCESS.DELETE`), '', null, null, !props.isHistoryTreatment ? 'register-page' : '')
                canvasRef.current?.clearCanvas()
              }
            })
            .catch((e) => {
              const err = e.response.data
              notiError(t(`DOCTOR_NOTE.MESSAGE.${err.message}`), '', null, null, !props.isHistoryTreatment ? 'register-page' : '')
            })
        } else if (res && props.hasDeleteDoctorNote !== 'PERMISS') {
          notiError(t(`DOCTOR_NOTE.MESSAGE.ERROR.NOTRIGHT`))
        }
      },
      { confirmButtonText: t(`DOCTOR_NOTE.BUTTON.DEL_NOTE`), cancelButtonText: t('BUTTON.CANCEL') }
    )
  }

  const handleSave = async () => {
    setIsSavePopup(true)
  }

  const handleSavePrint = () => {
    setIsSavePopup(true)
  }

  const handleCreateNote = async () => {
    setCreateNewNote(true)
    setShowDocumentDoctorNote(false)
  }

  const handlePrint = async () => {
    if (!canvasRef.current) {
      console.error('Canvas reference not found');
      return;
    }

    try {
      const drawingImage = await canvasRef.current.exportImage('png');
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`
          <style>
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
            }
            img {
              max-width: 100%;
              min-width: 100%;
              min-height: 100%;
              max-height: 100%;
            }
          </style>
          <img src="${drawingImage}" alt="Canvas Drawing" />
        `);
        newWindow.document.close();

        newWindow.onload = () => {
          newWindow.print();
        };
      }
    } catch (error) {
      console.error('Error in handlePrint:', error);
    }
  };

  // const handlePrint = async () => {
  //   if (canvasRef.current) {
  //     // สร้าง div ชั่วคราวเพื่อเก็บรูปภาพ
  //     const printContainer = document.createElement('div');
  //     const drawingImage = await canvasRef.current.exportImage('png');
  //     // ตั้งค่าการจัดตำแหน่งรูปภาพให้อยู่กลางหน้า
  //     printContainer.style.display = 'flex';
  //     printContainer.style.justifyContent = 'center';
  //     printContainer.style.alignItems = 'center';
  //     printContainer.style.height = '100vh';
  //     printContainer.style.margin = '0';

  //     // ใส่รูปภาพที่ต้องการพิมพ์
  //     printContainer.innerHTML = `
  //   <img src="${drawingImage}" alt="Canvas Drawing" id="imageToPrint" style="max-width: 100%; height: auto;" />
  // `;

  //     // เพิ่ม div นี้ลงใน body
  //     document.body.appendChild(printContainer);

  //     // ใช้ @media print เพื่อให้รูปภาพแสดงผลในขนาดที่พอดี
  //     const style = document.createElement('style');
  //     style.innerHTML = `
  //   @media print {
  //     body {
  //       margin: 0;
  //       padding: 0;
  //       display: block;
  //     }
  //     img {
  //       max-width: 100%;
  //       max-height: 100%;
  //       min-width: 100%;
  //       min-height: 100%;
  //     }
  //   }
  // `;
  //     document.head.appendChild(style);

  //     // เรียกใช้ window.print() เพื่อพิมพ์
  //     window.print();

  //     // ลบ div ชั่วคราวและ style หลังจากพิมพ์เสร็จ
  //     document.body.removeChild(printContainer);
  //     document.head.removeChild(style);
  //   }
  // };


  const checkHeaderDrawingZoneBigSize = () => {
    if (doctorNoteDetail) {
      return (
        <Col xs={12} xl={12} className="order-2 order-xl-1 px-0" style={{ border: `0px solid ${colors.lightGray}` }}>
          <UseStyled.TreatmentListItem className="d-xl-flex flex-column">
            {doctorNoteId === 0 ? (
              <UseStyled.TypographyTitle
                className={'pb-2'}
                style={{ border: `1px solid ${colors.lightGray}`, borderStyle: 'solid none solid solid', textAlign: 'start', fontSize: '16px', backgroundColor: colors.white, minHeight: '50px', paddingTop: '15px', paddingLeft: '10px' }}
              >
                <span style={{ color: '#929292' }}>{t('DOCTOR_NOTE.WATCH_NOTE_NOW')}</span>
                <span style={{ backgroundColor: colors.lightGray, marginLeft: '10px' }}>{` ${t('DOCTOR_NOTE.NOTE_DRAFT')} `}</span>
              </UseStyled.TypographyTitle>
            ) : (
              <UseStyled.TypographyTitle
                className={'pb-2'}
                style={{ border: `1px solid ${colors.lightGray}`, borderStyle: 'solid none solid solid', textAlign: 'start', fontSize: '16px', backgroundColor: colors.white, minHeight: '50px', paddingTop: '15px', paddingLeft: '10px' }}
              >
                <span style={{ color: '#929292' }}>{t('DOCTOR_NOTE.WATCH_NOTE_NOW')}</span>
                <span>{` VN ${props.patient?.patientCase?.vnNumber} ${toBuddhistYear(moment(listDoctorNote[0]?.createdAt), 'DD/MM/YYYY')} > ${doctorNoteDetail.doctorNoteName} `}</span>
                <span style={{ color: '#929292' }}>({toBuddhistYear(moment(doctorNoteDetail.createdAt), 'DD/MM/YYYY')})</span>
              </UseStyled.TypographyTitle>
            )}
          </UseStyled.TreatmentListItem>
        </Col>
      )
    } else {
      return (createNewNote ? (
        <Col xs={12} xl={12} className="order-2 order-xl-1 px-0" style={{ border: `0px solid ${colors.lightGray}` }}>
          <UseStyled.TreatmentListItem className="d-xl-flex flex-column">
            <UseStyled.TypographyTitle
              className={'pb-2'}
              style={{ border: `1px solid ${colors.lightGray}`, borderStyle: 'solid none solid solid', textAlign: 'start', fontSize: '16px', backgroundColor: colors.white, minHeight: '50px', paddingTop: '15px', paddingLeft: '10px' }}
            >
              <span style={{ color: '#929292' }}>{t('DOCTOR_NOTE.WATCH_NOTE_NOW')}</span>
              <span style={{ backgroundColor: colors.lightGray, marginLeft: '10px' }}>{` ${t('DOCTOR_NOTE.NOTE_DRAFT')} `}</span>
            </UseStyled.TypographyTitle>
          </UseStyled.TreatmentListItem>
        </Col>
      ) : (
        <Col xs={12} xl={12} className="order-2 order-xl-1 px-0" style={{ border: `0px solid ${colors.lightGray}` }}>
          <UseStyled.TreatmentListItem className="d-xl-flex flex-column">
            <UseStyled.TypographyTitle
              className={'pb-2'}
              style={{ border: `1px solid ${colors.lightGray}`, borderStyle: 'solid none solid solid', textAlign: 'start', fontSize: '16px', backgroundColor: colors.white, minHeight: '50px', paddingTop: '15px', paddingLeft: '10px' }}
            >
              {t('DOCTOR_NOTE.WATCH_NOTE_EMPTY')}
            </UseStyled.TypographyTitle>
          </UseStyled.TreatmentListItem>
        </Col>
      ))
    }
  }

  const checkHeaderDrawingZoneSmallSize = () => {
    if (doctorNoteDetail) {
      return (
        <Col xs={12} xl={12} className="order-2 order-xl-1 px-0" style={{ border: `0px solid ${colors.lightGray}` }}>
          <UseStyled.TreatmentListItem className="d-xl-flex flex-column">
            <UseStyled.TypographyTitle
              className={'pb-2'}
              style={{
                border: `1px solid ${colors.lightGray}`,
                borderStyle: 'solid none solid solid',
                textAlign: 'start',
                fontSize: '16px',
                backgroundColor: colors.white,
                minHeight: '50px',
                paddingTop: '15px',
                paddingLeft: '10px',
                justifyContent: 'center',
                display: 'flex'
              }}
            >
              <span style={{}}>{t('DOCTOR_NOTE.ALL_PAGE')}</span>
              <span>{` (${listDoctorNote.length}) หน้า`}</span>
            </UseStyled.TypographyTitle>
          </UseStyled.TreatmentListItem>
        </Col>
      )
    } else {
      return (createNewNote ? (
        <Col xs={12} xl={12} className="order-2 order-xl-1 px-0" style={{ border: `0px solid ${colors.lightGray}` }}>
          <UseStyled.TreatmentListItem className="d-xl-flex flex-column">
            <UseStyled.TypographyTitle
              className={'pb-2'}
              style={{ border: `1px solid ${colors.lightGray}`, borderStyle: 'solid none solid solid', textAlign: 'start', fontSize: '16px', backgroundColor: colors.white, minHeight: '50px', paddingTop: '15px', paddingLeft: '10px' }}
            >
              <span style={{ color: '#929292' }}>{t('DOCTOR_NOTE.WATCH_NOTE_NOW')}</span>
              <span style={{ backgroundColor: colors.lightGray, marginLeft: '10px' }}>{` ${t('DOCTOR_NOTE.NOTE_DRAFT')} `}</span>
            </UseStyled.TypographyTitle>
          </UseStyled.TreatmentListItem>
        </Col>
      ) : (
        <Col xs={12} xl={12} className="order-2 order-xl-1 px-0" style={{ border: `0px solid ${colors.lightGray}` }}>
          <UseStyled.TreatmentListItem className="d-xl-flex flex-column">
            <UseStyled.TypographyTitle
              className={'pb-2'}
              style={{ border: `1px solid ${colors.lightGray}`, borderStyle: 'solid none solid solid', textAlign: 'start', fontSize: '16px', backgroundColor: colors.white, minHeight: '50px', paddingTop: '15px', paddingLeft: '10px' }}
            >
              {t('DOCTOR_NOTE.WATCH_NOTE_EMPTY')}
            </UseStyled.TypographyTitle>
          </UseStyled.TreatmentListItem>
        </Col>
      ))
    }
  }

  const saveDrawing = async () => {
    if (statusNote === 'TEXT') {
      handleSavePrint()
    } else {
      setIsSavePopup(true)
      if (canvasRef.current) {
        try {
          // ใช้ await เพื่อรอผลลัพธ์จาก exportPaths()
          const pathsData: any = await canvasRef.current.exportPaths();
          const imageData = await canvasRef.current.exportImage("png");
          setCanvasData(pathsData)
          setCanvasImageData(imageData)
        } catch (error) {
          console.error('Failed to export paths:', error);
        }
      }
    }
  };

  return (
    <DivDoctorNote>
      {/* style={{ minHeight: '500px' }} */}
      <Row >
        {width >= 1200 ? (
          checkHeaderDrawingZoneBigSize()
        ) :
          checkHeaderDrawingZoneSmallSize()
        }

        <p>
          <span style={{ color: 'orange' }}>ข้อมูลก่อนอัปเดต (27 ม.ค. 2568) ไม่สามารถลบได้โดยตรง แนะนำให้ใช้สีขาวทับหรือล้างข้อมูลก่อนเขียนใหม่</span>
          {` `}ข้อมูลหลังอัปเดต สามารถเขียนและลบได้ตามปกติ{` `}
          ทีมงานกำลังปรับปรุงฟังก์ชันให้ดียิ่งขึ้น ขออภัยในความไม่สะดวก!
        </p>
        {createNewNote ? (
          <Col xs={12} xl={8 + (showDocumentDoctorNote ? 0 : 3)} className={`order-2 order-xl-1 px-0 h-100 `} style={{ border: `1px solid ${colors.lightGray}` }}>
            {/* <CanvasDisign
              submit={(dataURL: any, dataObject: any) => handleCanvasSubmit(dataURL, dataObject)}
              dataUrl={doctorNoteDetail ? doctorNoteDetail.base64Note : ''}
              dataObject={doctorNoteDetail ? doctorNoteDetail.objectNote : null}
              doctorNoteId={doctorNoteId ? doctorNoteId : 0}
              brushColor={brushColor}
              brushSize={brushSize}
              hasDoctorNote={props.hasDoctorNote}
              hasCreateDoctorNote={props.hasCreateDoctorNote}
              isHistoryTreatment={props.isHistoryTreatment}
              loadDoctorNote={() => loadDoctorNote()}
              setNewPage={() => handleNewCanvas()}
              hasDeleteDoctorNote={props.hasDeleteDoctorNote}
              statusNote={statusNote}
              setStatusNode={setStatusNode}
              submitPrint={handleSavePrint}
              textDoctorNote={textDoctorNote}
              setTextDoctorNote={setTextDoctorNote}
            /> */}
            <PageModal
              isOpen={isSavePopup}
              size='XS'
              title='บันทึกโน้ต'
              handleClose={() => setIsSavePopup(false)}
              onCancel={{ onClick: () => setIsSavePopup(false) }}
              onSubmit={{ onClick: () => submit(titleNote, canvasData, canvasImageData) }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center" marginY="24px" gap="16px">
                <Typography width="60px">ชื่อโน้ต</Typography>
                <TextInput onChange={(e) => setTitleNote(e.target.value)} value={titleNote} label='ชื่อโน้ต' required fullWidth />
              </Box>
            </PageModal>
            <Box display="flex" justifyContent="space-between" alignItems="center" marginY="10px" marginX="8px">
              <Box display="flex" flexDirection="row" gap="8px" alignItems="center">
                <MainButton onClick={() => {
                  if (statusNote === 'WRITE') {
                    setStatusNode('TEXT')
                    setTextDoctorNote("")
                  } else {
                    setTextDoctorNote("")
                    loadDoctorNote()
                    setStatusNode('WRITE')
                  }
                }} title='เลือกแบบพิมพ์' type='primary' variant='outlined' startIcon={'T'} />
                {statusNote === 'WRITE' &&
                  <>
                    <RedoIcon sx={{ cursor: 'pointer' }} onClick={() => canvasRef.current?.undo()} />
                    <UndoIcon sx={{ cursor: 'pointer' }} onClick={() => canvasRef.current?.redo()} />
                  </>
                }
              </Box>
              {statusNote === 'WRITE' &&
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Box position="relative" sx={{ cursor: 'pointer' }}>
                    {isOpenPencil ?
                      <Box bgcolor="#E5E5E5" gap="16px" display="flex" justifyContent="space-between" alignItems="center" paddingX="8px" paddingY="4px" borderRadius="20px">
                        <Box borderRadius="100px" width="32px" height="32px" bgcolor="white" display="flex" justifyContent="center" alignItems="center"><IconPencil onClick={() => {
                          setIsOpenPencil(!isOpenPencil)
                          canvasRef.current?.eraseMode(false);
                        }} /></Box>
                        <Box width="8px" height="8px" borderRadius="100px" bgcolor="black"></Box>
                        <Box width="24px" height="24px" borderRadius="100px" bgcolor={colorCanvas}></Box>
                      </Box>
                      :
                      <Box borderRadius="100px" width="32px" height="32px" bgcolor="white" display="flex" justifyContent="center" alignItems="center"><IconPencil onClick={() => {
                        setIsOpenPencil(!isOpenPencil)
                        canvasRef.current?.eraseMode(false);
                      }} /></Box>}
                    {isOpenPencil && <Box position="absolute" ref={pencilRef}>
                      <Box padding="16px" bgcolor="white" width="256px" boxShadow="0px 10px 15px 0px #1F29371A" borderRadius="8px">
                        <Typography fontSize="16px" fontWeight={400} marginBottom="8px">ขนาด</Typography>
                        <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setPencilWidth(5)
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="5px" height="5px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setPencilWidth(8)
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="8px" height="8px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setPencilWidth(12)
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="12px" height="12px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setPencilWidth(16)
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="16px" height="16px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setPencilWidth(20)
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="20px" height="20px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setPencilWidth(24)
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                        </Box>
                        <Typography fontSize="16px" fontWeight={400} marginY="8px">สี</Typography>
                        <Box display="flex" flexDirection="row" alignItems="center" gap="16px" marginBottom="8px">
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setColorCanvas('black')
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="black" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setColorCanvas('#B00020')
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="#B00020" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setColorCanvas('#33689C')
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="#33689C" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setColorCanvas('#1CB99A')
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="#1CB99A" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setColorCanvas('#EDBA07')
                            setIsOpenPencil(false)
                          }}>
                            <Box bgcolor="#EDBA07" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                          <AddIcon onClick={() => setColor(!color)} sx={{ color: '#808080' }} />
                        </Box>

                        {color && <ChromePicker color={colorCanvas} onChange={(e) => setColorCanvas(e.hex)} disableAlpha />}
                      </Box>
                    </Box>}
                  </Box>
                  <Box position="relative" sx={{ cursor: 'pointer' }}>
                    {isOpenRubber ?
                      <Box bgcolor="#E5E5E5" gap="16px" display="flex" justifyContent="space-between" alignItems="center" paddingX="8px" paddingY="4px" borderRadius="20px">
                        <Box borderRadius="100px" width="32px" height="32px" bgcolor="white" display="flex" justifyContent="center" alignItems="center">
                          <IconRubber onClick={() => {
                            setIsOpenRubber(true)
                            canvasRef.current?.eraseMode(true);
                          }} /></Box>
                        <Box width="8px" height="8px" borderRadius="100px" bgcolor="black"></Box>
                      </Box>
                      : <Box borderRadius="100px" width="32px" height="32px" bgcolor="white" display="flex" justifyContent="center" alignItems="center"><IconRubber onClick={() => {
                        setIsOpenRubber(true)
                        canvasRef.current?.eraseMode(true);
                      }} /></Box>}
                    {isOpenRubber && <Box position="absolute" ref={rubberRef}>
                      <Box padding="16px" bgcolor="white" width="256px" boxShadow="0px 10px 15px 0px #1F29371A" borderRadius="8px">
                        <Typography fontSize="16px" fontWeight={400} marginBottom="8px">ขนาด</Typography>
                        <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setRubberWidth(4)
                            setIsOpenRubber(false)
                          }}>
                            <Box bgcolor="black" width="4px" height="4px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setRubberWidth(8)
                            setIsOpenRubber(false)
                          }}>
                            <Box bgcolor="black" width="8px" height="8px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setRubberWidth(12)
                            setIsOpenRubber(false)
                          }}>
                            <Box bgcolor="black" width="12px" height="12px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setRubberWidth(16)
                            setIsOpenRubber(false)
                          }}>
                            <Box bgcolor="black" width="16px" height="16px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setRubberWidth(20)
                            setIsOpenRubber(false)
                          }}>
                            <Box bgcolor="black" width="20px" height="20px" borderRadius="100px"></Box>
                          </Box>
                          <Box display="flex" justifyContent="center" alignItems="center" width="24px" height="24px" onClick={() => {
                            setRubberWidth(24)
                            setIsOpenRubber(false)
                          }}>
                            <Box bgcolor="black" width="24px" height="24px" borderRadius="100px"></Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>}
                  </Box>
                </Box>
              }
              <Box display="flex" flexDirection="row" gap="8px">
                <MainButton onClick={() => {
                  if (statusNote === 'TEXT') {
                    setTextDoctorNote('')
                  } else {
                    if (canvasRef.current) {
                      canvasRef.current.clearCanvas();
                    }
                    setDataImage('')
                  }
                }} title='ล้าง' type='danger' variant='outlined' style={{ width: '100px' }} />
                {dataCanvas && <MainButton onClick={() => {
                  if (canvasRef.current) {
                    canvasRef.current.clearCanvas();
                    canvasRef.current.loadPaths(dataCanvas)
                  }
                }} title='ยกเลิก' type='secondary' variant='outlined' style={{ width: '100px' }} />}
                <MainButton onClick={saveDrawing} title='บันทึก' type='primary' variant='contained' style={{ width: '100px' }} />
              </Box>
            </Box>

            {statusNote === 'WRITE' ? <Box display="flex" justifyContent="center" bgcolor="#E5E5E5">
              <Box bgcolor='white'>
                <ReactSketchCanvas
                  ref={canvasRef}
                  allowOnlyPointerType='all'
                  width="500px"
                  height="600px"
                  // smoothing={true}
                  // brushRadius={pencilWidth/2}
                  strokeColor={colorCanvas}
                  strokeWidth={pencilWidth}
                  eraserWidth={rubberWidth}
                  backgroundImage={dataImage}
                />
              </Box>
            </Box> :
              <TextAreaInput
                placeholder={t('DOCTOR_NOTE.INPUT_TEXT')}
                onChange={(e) => setTextDoctorNote(e.target.value)}
                value={textDoctorNote}
                rows={12}
                fullWidth
                inputProps={{ value: textDoctorNote }}
              />}
          </Col>
        ) : (
          <Col xs={12} xl={12} className="order-2 order-xl-1 px-0 h-100" style={{ border: `1px solid ${colors.lightGray}` }}>
            <Col style={{ height: 700 }}>
              <Col style={{ height: 650, border: `1px solid ${colors.lightGray}`, margin: '50px' }}>
                <Col style={{ textAlign: 'center', paddingTop: '250px' }}>{t('DOCTOR_NOTE.SUGGESTION')} </Col>
                <Col style={{ textAlign: 'center', paddingTop: '30px', color: colors.themeSecondColor }}>
                  <a onClick={() => handleCreateNote()}>{t('DOCTOR_NOTE.BUTTON.CREATE_NOTE')}</a>
                </Col>
              </Col>
            </Col>
          </Col>
        )}
        {showDocumentDoctorNote ? (
          <Col xl={4} className="order-1 order-xl-2 px-3 h-100 overflow-auto">
            <Row style={{ marginTop: '10px' }}>
              <Col xl={10}>
                <strong>
                  {t('DOCTOR_NOTE.ALL_PAGE')}
                  {`(${statusNote !== 'TEXT' ? listDoctorNote?.length : listDoctorNoteText?.length})`}
                </strong>
              </Col>
              <Col className={`col-auto`} style={{ pointerEvents: 'auto' }}>
                <ImgIconDoctorNote onClick={() => handlePrint()} src={iconPrint} style={{ filter: !listSelectDoctorNote?.length ? 'grayscale(1)' : '' }} />
                {/* <FucntionPrint
                  content={() => componentRef?.current}
                  docTitle={"PreviewImg"}
                  removeIfram
                  trigger={() => (
                    <Col className={`col-auto px-1 ${props.hasDoctorNote === 'UNPERMISS' ? 'pe-none opacity-0' : ''}`}>
                      <ImgIconDoctorNote className="" src={iconPrint} style={{ filter: !listSelectDoctorNote?.length ? 'grayscale(1)' : '' }} />
                    </Col>
                  )}
                  style={`@page { size: 794px 1123px; ${statusNote !== 'WRITE' && 'margin: 0.5cm;'} } @media print { body { -webkit-print-color-adjust: exact; } `}
                /> */}
              </Col>
            </Row>
            {/* ml-5 */}
            <Row className="mx-0 custom-scroll" style={{ maxHeight: '725px', overflow: 'hidden', overflowY: 'scroll', marginTop: '5px' }}>
              {(props.hasDoctorNote !== 'UNPERMISS' && !props.isHistoryTreatment) && (
                <Col style={{ height: '130px', width: '150px' }} className={`col-auto px-0 m-1 list-doctor-note ${(doctorNoteId === 0) && 'active'}`} onClick={() => handleNewCanvas()}>
                  <div className="d-flex flex-center p-2 h-100">
                    <div className="text-center">
                      <img id="img-add-note" alt="" className="img-add-note" src={iconAddFile} />
                      <p className="mb-0 mt-1 fz-14 text-muted">{t('DOCTOR_NOTE.ADD_PAPER')}</p>
                    </div>
                  </div>
                </Col>
              )}
              {_.map(statusNote !== 'TEXT' ? listDoctorNote : listDoctorNoteText, (doctorNote: any, i: number) => {
                const idDoctorNote = doctorNote?.doctorNoteId
                const isEdit = idDoctorNote === doctorNoteId
                return (
                  <Col
                    style={{ height: '130px', width: '150px' }}
                    key={i}
                    className={`col-auto m-1 px-0 list-doctor-note ${(isEdit) && 'active'}`}
                    onClick={() => handleEditCanvas(doctorNote, i)}
                  >
                    <div className="position-relative overflow-hidden h-100 w-100">
                      <Box
                        className={`d-flex align-items-center justify-content-end position-absolute w-100 `}
                        sx={{ marginTop: isEdit ? '-1px' : '0px' }}
                      >
                        {/* <Box sx={{ '.MuiCheckbox-root': { padding: '4px !important' } }}>
                          <InputCheckbox
                            checked={listSelectDoctorNote && listSelectDoctorNote.some((item: any) => item?.doctorNoteId === idDoctorNote)}
                            onChange={() => handleSelectListDoctorNote(doctorNote)}
                          />
                        </Box> */}
                        {(isEdit && !props.isHistoryTreatment) && (
                          <Box sx={{ padding: '4px' }}>
                            <IconButton
                              className={'btn-delete'}
                              aria-label="delete"
                              onClick={() => {
                                detroy(doctorNote.doctorNoteId)
                              }}
                              sx={{ backgroundColor: 'transparent !important', padding: '0px' }}
                            >
                              <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                            </IconButton>
                          </Box>

                        )}
                      </Box>

                      {statusNote !== 'TEXT' ?
                        // ref={componentRef}
                        <div >
                          <img id={`doctor-note-render-${doctorNote.doctorNoteId}`} src={doctorNote.base64New || doctorNote.base64Note} onError={onImgError} style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt="" />
                        </div>
                        :
                        <Box sx={{ padding: '6px', height: 'calc(100% - 30px)', overflow: 'auto', }}>
                          <Box sx={{ fontSize: '8px', lineHeight: '1' }}>
                            {doctorNote?.textNote?.split('\n')?.length ?
                              doctorNote?.textNote?.split('\n').map((line: any, index: number) => (
                                <Box key={index} sx={{ height: '100%', wordWrap: 'break-word' }}>{line}</Box>
                              )) :
                              <Box></Box>
                            }
                          </Box>
                        </Box>
                      }
                    </div>
                    <Tooltip title={(<>
                      <div>{t('DOCTOR_NOTE.CREATOR')} {doctorNote.createdBy}</div>
                      <div> {t('DOCTOR_NOTE.EDITOR')} {doctorNote.updatedBy}</div></>)} placement="top">
                      <div className="position-relative" style={{ backgroundColor: 'white', marginTop: '-30px', height: '30px' }}>
                        <Row xs={12} xl={12}>
                          <Col xs={6} xl={6} style={{ fontSize: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <span><img src={iconCreatedBy} />{t('DOCTOR_NOTE.CREATOR')} {doctorNote.createdBy}</span>
                          </Col>
                          <Col xs={6} xl={6} style={{ fontSize: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <img src={iconCreatedAt} /> {toBuddhistYear(moment(doctorNote.createdAt), 'DD/MM/YY')}
                          </Col>
                        </Row>
                        <Row xs={12} xl={12}>
                          <Col xs={6} xl={6} style={{ fontSize: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <span>
                              <img src={iconUpdateBy} />
                              {t('DOCTOR_NOTE.EDITOR')}
                              {doctorNote.updatedBy}
                            </span>
                          </Col>
                          <Col xs={6} xl={6} style={{ fontSize: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <img src={iconUpdateAt} /> {toBuddhistYear(moment(doctorNote.updatedAt), 'DD/MM/YY')}
                          </Col>
                        </Row>
                      </div>
                    </Tooltip>
                  </Col>
                )
              })}
            </Row>
          </Col>
        ) : (
          <Col xl={1} className="order-1 order-xl-2 px-3 h-100 overflow-auto">
            <Row>
              <ButtonCustom variant={'outlined'} style={{ fontSize: '12px', marginTop: '5px' }} textButton={t('DOCTOR_NOTE.ALL_PAGE')} onClick={openShowDocumentDoctorNote} />
            </Row>
            {_.map(listDoctorNote, (doctorNote: any, i: number) => (
              <Col hidden style={{ height: '130px', width: '130px' }} key={i} className={`col-auto m-1 px-0 list-doctor-note ${doctorNote.doctorNoteId === doctorNoteId && 'active'}`} onClick={() => handleEditCanvas(doctorNote)}>
                <div className="position-relative overflow-hidden h-100 w-100">
                  <div >
                    <img id={`doctor-note-render-${doctorNote.doctorNoteId}`} src={doctorNote.base64Note} onError={onImgError} style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt="" />
                  </div>
                </div>
              </Col>
            ))}
          </Col>
        )}
      </Row>

      {/* <SavePopup isShow={isSavePopup} doctorNoteDetail={doctorNoteDetail} onCancel={() => setIsSavePopup(false)} onSubmit={submit} vnNumber={visitActive} /> */}
      {/* <Box className="print-show h-100 w-100" sx={{ maxWidth: '100%' }} ref={componentRef}>
        <PdfDoctorNote
          statusNote={statusNote}
          listSelectDoctorNote={listSelectDoctorNote}
          patient={props.patient}
        />
      </Box> */}

    </DivDoctorNote>
  )
}

type PdfDoctorNoteProps = {
  statusNote: StatusNoteProps
  listSelectDoctorNote: any[]
  patient: any
}

const PdfDoctorNote = (props: PdfDoctorNoteProps) => {
  const { statusNote, listSelectDoctorNote, patient } = props

  const { t } = useTranslation()
  const branchInfo = getClinicInfo()

  if (statusNote === "WRITE") {
    return (
      <Box>
        {listSelectDoctorNote?.length && listSelectDoctorNote.map((item, index) => {
          return (
            <Box key={index}>
              <img id={`doctor-note-render-${item?.doctorNoteId}`} src={item?.base64Note} onError={onImgError} style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt="" />
            </Box>
          )
        })}
      </Box>
    )
  } else {
    return (
      <Box sx={{ padding: '24px 32px' }}>
        <Box sx={{ fontSize: '8px', marginBottom: '32px' }}>
          <Box >
            {`${branchInfo?.clinicName || ''} ${t('DOCTOR_NOTE.PATIENT_ID_BRANCH')} ${patient?.cnNumber} ${t('DOCTOR_NOTE.NAME')} ${patient?.prefix?.prefixName} ${patient?.firstname} ${patient?.lastname}`}
          </Box>
          <Box>
            {`${t('DOCTOR_NOTE.ADDRESS')} ${branchInfo?.receiptFullAddress} ${t('DOCTOR_NOTE.PHONE')} ${branchInfo?.branchTel || branchInfo?.branchPhone1 || branchInfo?.branchPhone || ''}`}
          </Box>
        </Box>
        <Box
          sx={{
            'table': {
              borderCollapse: 'collapse',
              width: '100%',
              fontSize: '8px'
            },
            'th': {
              border: '1px solid ',
              textAlign: 'center',
              padding: '10px 4px',
            },
            '.col-update': {
              width: '40px'
            },
            'td': {
              border: '1px solid ',
              padding: '8px',
            },
            '.row-update': {
              textAlign: 'center',
              padding: '10px 4px',
              alignContent: 'flex-start'
            },
            '.row-text': {
              textAlign: 'left',
              padding: '4px',
            }
          }}
        >
          <table>
            <tr>
              <th className={`col-update`}>{t('DOCTOR_NOTE.PDF_DATE')}</th>
              <th></th>
            </tr>
            {listSelectDoctorNote?.length && listSelectDoctorNote.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={`row-update`}>{toBuddhistYear(moment(), 'DD/MM/YYYY')}</td>
                  <td className={`row-text`} style={{ lineHeight: '1' }}>
                    {item?.textNote?.split('\n')?.length ?
                      item?.textNote?.split('\n').map((line: any, index: number) => (
                        <Box key={index} sx={{ height: '100%', wordWrap: 'break-word' }}>{line}</Box>
                      )) :
                      <Box ></Box>
                    }
                  </td>
                </tr>
              )
            })}
          </table>
        </Box>
      </Box>
    )
  }
}
